import { Helmet } from "react-helmet-async";

const SITE = "Club Infinity";
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

export function Seo({ title, description, image, path = "", type = "website", jsonLd }) {
  const full = title ? `${title} | ${SITE}` : `${SITE} — Central de Suporte e Configuração`;
  const desc = description || "Tutoriais passo a passo para configurar Smart TV, TV Box, Fire TV, celular e mais. Suporte direto pelo WhatsApp.";
  const img = image || `${ORIGIN}/logo.png`;
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet>
      <html lang="pt-BR" />
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="pt_BR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
